import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    if (!cookieConsent) {
      setShowBanner(true);
    } else {
      const savedPreferences = JSON.parse(cookieConsent);
      setPreferences(savedPreferences);
      activateScripts(savedPreferences);
    }
  }, []);

  const activateScripts = (prefs) => {
    if (prefs.analytics) {
      activateGoogleAnalytics();
    }
    if (prefs.marketing) {
      activateMetaPixel();
    }
  };

  const activateGoogleAnalytics = () => {
    if (!window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX';
      document.head.appendChild(script);
      
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', 'G-XXXXXXXXXX', { 'anonymize_ip': true });
    }
  };

  const activateMetaPixel = () => {
    if (!window.fbq) {
      (function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', 'XXXXXXXXXXXXXXX');
      window.fbq('track', 'PageView');
    }
  };

  const saveConsent = (prefs) => {
    localStorage.setItem('cookieConsent', JSON.stringify(prefs));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setPreferences(prefs);
    activateScripts(prefs);
    setShowBanner(false);
    setShowPreferences(false);
  };

  const acceptAll = () => {
    saveConsent({ necessary: true, analytics: true, marketing: true });
  };

  const rejectAll = () => {
    saveConsent({ necessary: true, analytics: false, marketing: false });
  };

  const savePreferences = () => {
    saveConsent(preferences);
  };

  const handlePreferenceChange = (type) => {
    if (type === 'necessary') return;
    setPreferences(prev => ({ ...prev, [type]: !prev[type] }));
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Compact Floating Banner */}
      {!showPreferences && (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-xl shadow-2xl border border-gray-200 z-50 p-3">
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs text-gray-600 flex-1">
              🍪 Usiamo cookie.{' '}
              <Link to="/cookie-policy" className="text-green-700 underline">Info</Link>
            </p>
            <div className="flex items-center gap-2">
              <button
                onClick={rejectAll}
                className="px-3 py-1.5 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors text-xs font-medium"
              >
                Rifiuta
              </button>
              <button
                onClick={acceptAll}
                className="px-3 py-1.5 bg-green-700 text-white rounded-lg hover:bg-green-800 transition-colors text-xs font-medium"
              >
                Accetta
              </button>
              <button
                onClick={() => setShowPreferences(true)}
                className="p-1.5 text-gray-400 hover:text-gray-600 transition-colors"
                aria-label="Preferenze cookie"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preferences Modal - Compact */}
      {showPreferences && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end md:items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            <div className="p-4 border-b border-gray-100 flex items-center justify-between">
              <h2 className="font-bold text-gray-800">Preferenze Cookie</h2>
              <button 
                onClick={() => setShowPreferences(false)}
                className="text-gray-400 hover:text-gray-600 text-xl leading-none p-1"
                aria-label="Chiudi"
              >
                ×
              </button>
            </div>
            
            <div className="p-4 space-y-2">
              {/* Cookie Tecnici */}
              <div className="flex items-center justify-between p-2.5 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-800 text-sm">Tecnici</p>
                  <p className="text-xs text-gray-500">Necessari</p>
                </div>
                <div className="w-9 h-5 bg-green-500 rounded-full relative">
                  <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white rounded-full"></div>
                </div>
              </div>

              {/* Cookie Analitici */}
              <div className="flex items-center justify-between p-2.5 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-800 text-sm">Analytics</p>
                  <p className="text-xs text-gray-500">Statistiche anonime</p>
                </div>
                <button
                  onClick={() => handlePreferenceChange('analytics')}
                  className={`w-9 h-5 rounded-full relative transition-colors ${preferences.analytics ? 'bg-blue-500' : 'bg-gray-300'}`}
                >
                  <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${preferences.analytics ? 'right-0.5' : 'left-0.5'}`}></div>
                </button>
              </div>

              {/* Cookie Marketing */}
              <div className="flex items-center justify-between p-2.5 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-800 text-sm">Marketing</p>
                  <p className="text-xs text-gray-500">Pubblicità personalizzata</p>
                </div>
                <button
                  onClick={() => handlePreferenceChange('marketing')}
                  className={`w-9 h-5 rounded-full relative transition-colors ${preferences.marketing ? 'bg-purple-500' : 'bg-gray-300'}`}
                >
                  <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${preferences.marketing ? 'right-0.5' : 'left-0.5'}`}></div>
                </button>
              </div>
            </div>
            
            <div className="p-4 border-t border-gray-100 flex gap-2">
              <button
                onClick={rejectAll}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
              >
                Rifiuta tutti
              </button>
              <button
                onClick={savePreferences}
                className="flex-1 px-4 py-2 bg-green-700 text-white rounded-lg hover:bg-green-800 transition-colors text-sm font-medium"
              >
                Salva
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
